
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.667 25v2.5c0 .46.373.833.833.833h25c.46 0 .833-.373.833-.833V25c0-4.673-5.856-8.334-13.333-8.334S1.667 20.326 1.667 25zM21.667 8.333A6.674 6.674 0 0 0 15 1.666a6.674 6.674 0 0 0-6.667 6.667A6.674 6.674 0 0 0 15 15a6.674 6.674 0 0 0 6.667-6.667z","fill":"#8296A0"}})])
      }
    
      }
    